import { FC, memo } from 'react'
import s from './BuildInput.module.sass'
import { InputTitle } from '@shared/ui/Form/Single/InputTitle'
import { Input } from '@shared/ui/Form/Single/Input'
import { InputHint } from '@shared/ui/Form/Single/InputHint'
import { useFieldHint } from '@shared/lib/fields/hooks/useFieldHint/useFieldHint'
import {FieldBase, FieldInput, FieldInputTel} from '@shared/types/fields/fields'
import { BlockBoundary } from '../../../../lib/components/BlockBoundary'

interface Props {
  field: FieldBase | FieldInput | FieldInputTel
  setField: React.Dispatch<React.SetStateAction<FieldBase>>
   
  handleChange?: (value: string) => void
  className?: string
  denseHint?: boolean
}

const BuildInput: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  field,
  setField,
  handleChange,
  className = '',
  denseHint = false,
  ...props
}) => {
  const [hint] = useFieldHint(field)

  const setValue = (value: string): void => {
    setField((prev) => ({
      ...prev,
      value: value,
      error: '',
    }))

    handleChange && handleChange(value)
  }

  const classes = {
    disabled: !field.value && field.disabled ? s.disabled : '',
    disabledValue: !!field.value && field.disabled ? s.disabled__value : '',
  }

  return (
    <BlockBoundary>
      {field.visible && (
        <div className={`${s['input-group']} ${classes.disabled} ${classes.disabledValue} ${className}`} {...props}>
          <InputTitle
            nameField={field.name}
            title={field.settings.label}
            showRequired={field.required && field.settings.showRequired}
          />

          <Input field={field} handleValue={setValue} />

          <InputHint text={hint.text} status={hint.status} className={`${s['form-hint']} ${denseHint ? s['form-hint--dense'] : ''}`} />
        </div>
      )}
    </BlockBoundary>
  )
}

export default memo(BuildInput)
